import { AdService } from '../..'
import { IAdMobileStickyConfiguration } from '../../../../domain/conf/ads'
import { DOMUtils } from '../../../../utils/dom'

export class StickyMobileAd {

    public static init(conf: IAdMobileStickyConfiguration, count = 0) {

        if (DOMUtils.isMobile() && conf.enabled) {
            const topAd = document.querySelector(`.${AdService.DOM.classes.topAd.join('.')}`)
            const header = document.querySelector(`.${AdService.DOM.classes.header}`)

            if (header && topAd) {
                header.append(topAd)
                topAd.classList.add(AdService.DOM.classes.stickyAd)
                topAd.classList.add(AdService.DOM.classes.headerOffset)
                topAd.setAttribute(AdService.DOM.attrs.dataScroll, AdService.DOM.vals.dataScroll)

                if (conf.close) {
                    StickyMobileAd.enableCloseButton(topAd, conf.closeTimer)
                }
            // tslint:disable-next-line: no-magic-numbers
            } else if (count < 5) {
                // required for fast connections, which may load FEM before the top ad HTML tag
                // using event listeners for page load will not work for slow connections
                // tslint:disable-next-line: no-magic-numbers
                setTimeout(() => { StickyMobileAd.init(conf, count + 1) }, 50)
            }
        }
    }

    public static enableCloseButton(topAd: Element, time: number) {
        const closeButton = document.querySelector(`.${AdService.DOM.classes.closeStickyAd}`) as HTMLElement

        if (closeButton) {
            if (time > 0) {
                setTimeout(() => {
                    closeButton.style.display = 'inline'
                // tslint:disable-next-line: no-magic-numbers
                }, time * 1000)
            } else {
                closeButton.style.display = 'inline'
            }
            closeButton.addEventListener('click', () => { topAd.remove()})
        }
    }
}
